const bloodglucoseRouterMap = [
  {
    name: "血糖",
    path: "/bloodglucose/home",
    component: () => import("@/pages/bloodglucose/home"),
    meta: {
      systemCode: 'bloodglucose',
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "记录血糖",
    path: "/bloodglucose/addbloodsugar",
    component: () => import("@/pages/bloodglucose/addbloodsugar"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "胰岛素使用记录",
    path: "/bloodglucose/insulinrecord",
    component: () => import("@/pages/bloodglucose/insulinrecord"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "添加胰岛素使用记录",
    path: "/bloodglucose/addinsulinrecord",
    component: () => import("@/pages/bloodglucose/addinsulinrecord"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "选择药品",
    path: "/bloodglucose/druglist",
    component: () => import("@/pages/bloodglucose/druglist"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "新增药品",
    path: "/bloodglucose/adddrug",
    component: () => import("@/pages/bloodglucose/adddrug")
  },
  {
    name: "运动记录",
    path: "/bloodglucose/sportrecord",
    component: () => import("@/pages/bloodglucose/sportrecord"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "添加运动记录",
    path: "/bloodglucose/addsportrecord",
    component: () => import("@/pages/bloodglucose/addsportrecord"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "选择运动类型",
    path: "/bloodglucose/sportlist",
    component: () => import("@/pages/bloodglucose/sportlist"),
    meta: {
      isUseCache: false,
      keepAlive: true // 需要被缓存
    }
  },
  {
    name: "新增运动类型",
    path: "/bloodglucose/addsport",
    component: () => import("@/pages/bloodglucose/addsport")
  }
];

export default bloodglucoseRouterMap;
